<template>
  <div class="flex flex-col items-center justify-start w-90vw md:w-70vw">
    <p class="desc-content">众所周知，游戏的更新强度在整个生命周期内逐渐降低。表现在折线图上就是<span class="text-[#3fb1e3] mx-1">蓝线</span>整体呈现下降趋势。</p>
    <p class="desc-content">但是<span class="text-[#3fb1e3] mx-1">蓝线</span>存在俩次逆势上涨，第一次是2019年7月游戏正式公测，公测更新内容多也是意料之中吧。</p>
    <p class="desc-content">第二次是2021年12月的玉轮铃音版本，这个版本我们稍后再谈。</p>
    <p class="desc-content">
      <span class="text-[#6be6c1] mx-1">绿线</span>代表版本持续了多久，图表中<span
        class="text-[#6be6c1] mx-1 border-dashed border-b border-current">绿色虚线</span>是四个月，可以看到多数版本在这条线附近。
    </p>
    <p class="desc-content">
      假设玉轮铃音版本没有逆势上涨，那么<span class="text-[#3fb1e3] mx-1">蓝线</span>和<span
        class="text-[#6be6c1] mx-1">绿线</span>只会有一次相交——2020年7月结束的风动心弦版本。
    </p>
    <!-- 雅达利时刻 -->
    <h3 class="desc-p">
      古网的<a class="desc-a"
        href="https://baike.baidu.com/item/%E9%9B%85%E8%BE%BE%E5%88%A9%E5%A4%A7%E5%B4%A9%E6%BA%83/19754656"
        target="_blank">“雅达利时刻”</a>
    </h3>
    <p class="desc-content">
      本来这个时间点可以有更多的代表意义，但是在2020年7月11日<a class="desc-a" href="https://www.bilibili.com/video/BV1kV41167Rn"
        target="_blank">网元嘉年华</a>上公布了<a class="desc-a" href="https://www.bilibili.com/video/BV1vA411e7Fq"
        target="_blank">古网的UE4重制版 🎉</a>。
    </p>
    <p class="desc-content">
      既然有这个重大的好消息，那么2020年几个版本的敷衍都无足轻重了，毕竟全新的古网就在未来。
    </p>

    <p class="desc-content">
      转眼到了<a class="desc-a" href="https://www.bilibili.com/video/BV1ML4y1Y71K"
        target="_blank">2021年7月24日网元嘉年华</a>，直播中公布了<a class="desc-a" href="https://www.bilibili.com/video/BV1Dw41197j2"
        target="_blank">UE4重制版第二支视频。</a>
    </p>
    <p class="desc-content">
      直播中还公开了白荆回廊的上线日期和古剑四的第一张海报，这些都很好。
    </p>
    <p class="desc-content">
      除了一起公布的手游-木语人，日后这个项目的失败导致网元和B站对薄公堂。
    </p>

    <rambling text="一个暴论：木语人和神舞幻想2这二位堪称卧龙凤雏，合力抬走了老孟和古网" />

    <!-- 最后的荣光 -->
    <h3 class="desc-p">
      古网的“最后的荣光”
    </h3>
    <p class="desc-content">
      在2021年12月，版本玉轮铃音上线，也是图表中<span class="text-[#3fb1e3] mx-1">蓝线</span>第二次逆势上涨。
    </p>
    <p class="desc-content">
      比起更新强度的上升，这个版本对游戏内容的革新更加让人兴奋。
    </p>
    <p class="desc-content">
      尽管这个版本抛弃了之前的一些系统和设定，但是带来了最好的共享机制和饱受争议的路域通。可改变就是好事！
    </p>
    <p class="desc-content">
      这是公测之后古网改变最大的一个版本，之后的数个版本都是在玉轮铃音的基础上修修补补。
    </p>

    <p class="desc-content">
      时间来到2022年7月，<span class="text-[#3fb1e3] mx-1">蓝线</span>和<span class="text-[#6be6c1] mx-1">绿线</span>第二次相交。
    </p>

    <p class="desc-content">
      这个时间点之后的帝首熠兮版本持续时间异常的久，图中可以看到它超过了<span
        class="text-[#6be6c1] mx-1 border-dashed border-b border-current">绿色虚线</span>，而且紧接着几个版本更是山外有山。
    </p>

    <p class="desc-content">
      当下一次版本的持续时间降到<span class="text-[#6be6c1] mx-1 border-dashed border-b border-current">绿色虚线</span>以下时，迎接玩家的是新的时代。
    </p>

    <h3 class="desc-p">
      古网的“新时代”
    </h3>

    <p class="desc-content">
      到这里，熟悉古网的玩家应该已经在笑了吧？
    </p>

    <p class="desc-content">
      帝首熠兮版本的末期，几乎所有人都在问版本什么时候结束，只是那时没有人知道这是最后一个有实质性更新的版本。
    </p>
    <p class="desc-content">
      2023年12月，姗姗来迟的“新版本”上线了——寰宇会。
    </p>
    <p class="desc-content">
      它不同于以往的任何一个版本，更新的强度弱的可怜，可以在图表中看到<span class="text-[#3fb1e3] mx-1">蓝线</span>断层下降。
    </p>
    <p class="desc-content">
      而且几乎没有新的内容，只是对已有的内容排列组合。
    </p>
    <rambling>
      聊以慰籍的是寰宇会没有纳入古网官网的<a class="desc-a" href="https://gjol.wangyuan.com/info/huod/version.shtml"
        target="_blank">版本资料站</a>中。
    </rambling>
    <p class="desc-content">
      维持这个状态到今天，古网也只能说服务器还没有关，游戏的公告还在发。
    </p>
    <p class="desc-content">
      只是时间拨回到2021年7月24日，即使受到了新冠疫情的影响，我们仍然可以看到古网<a class="desc-a" href="https://www.bilibili.com/video/BV1Dw41197j2"
        target="_blank">UE4重制版最后一支视频</a>。至少网元在那时对古网的规划并非如今日所见。
    </p>
    <p class="desc-content">
      到底是什么打断了原本的计划，或许只有当事人清楚。不过还是有些信息值得关注。
    </p>
    <p class="desc-content">
      2022年02月22日哔哩哔哩申请对网元圣唐进行3679万元的财产保全[（2022）京01财保74号]。这就是上一节提到的木语人项目的失败所引发的纠纷。
    </p>
    <p class="desc-content">
      2022年10月26日,360公司申请财产保全网元3853万。[（2022）京01财保258号]，有传言这份财产保全是网元和360在古网渠道服务器的纠纷。
    </p>
    <p class="desc-content">
      2023年03月14日,上海维塔士电脑软件申请财产保全网元9139万[（2023）京0107财保76号]。这家公司是一个游戏外包商，可能是古网重置版的参与方。
    </p>
    <p class="desc-content">
      2023年09月01日，网元有一个3821万的被执行[（2023）京01执1116号]，大概率是360公司申请财产保全已经进入执行阶段。
    </p>

    <p class="desc-content">
      屋漏偏逢连夜雨，到这里，应该可以大胆猜测，2023年网元的资金不断恶化，不得不对手里的项目进行取舍。
    </p>

    <p class="desc-content">
      古网被放弃了。
    </p>

    <!-- <p class="desc-content">
      到今天我们都知道,<a class="desc-a" href="https://www.bilibili.com/video/BV1pT4y1p7Kd"
        target="_blank">白荆回廊如期上线</a>，古剑四也有了<a class="desc-a" href="https://www.bilibili.com/video/BV1WgYYzhEKw"
        target="_blank">第一支视频</a>,只有古网半截身子入了土
    </p> -->

  </div>
</template>

<script lang="ts" setup>

</script>

<style></style>